import { ConciergeContextSettingsParser } from "@redotech/redo-model/concierge-settings/context-settings-db-parser";
import * as z from "zod";

export const setConciergeContextSettings = {
  name: "setConciergeContextSettings" as const,
  input: ConciergeContextSettingsParser,
  output: z.object({ success: z.boolean() }),
};
